import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

interface Props {
  icon?: string;
  unit?: string;
  errorMessage?: string;
  displayError?: boolean;
  disabled?: boolean;
}

export const InputField = React.forwardRef<
  HTMLInputElement,
  Props & TextFieldProps
>((props, ref) => {
  const {
    id,
    type,
    name,
    label,
    value,
    unit,
    errorMessage,
    displayError,
    onChange,
    onBlur,
    disabled,
    icon,
    ...rest
  } = props;

  return (
    <Input
      id={id}
      name={name}
      type={type}
      ref={ref}
      disabled={disabled}
      value={value === null || value === undefined ? '' : value}
      onChange={onChange}
      onBlur={onBlur}
      label={label}
      error={displayError && errorMessage !== undefined}
      helperText={displayError && errorMessage}
      variant="outlined"
      autoComplete="off"
      InputProps={{
        ...(icon || unit
          ? {
              startAdornment: (
                <InputAdornment position="start">
                  {icon && <Adornment className={`${icon} fa-lg`} />}
                  {unit && <Adornment>{unit}</Adornment>}
                </InputAdornment>
              ),
              classes: { input: 'noscroll' }
            }
          : {
              classes: { input: 'noscroll' }
            })
      }}
      {...rest}
    />
  );
});

InputField.defaultProps = {
  type: 'text',
  disabled: false
};

const Input = styled(TextField)`
  width: 100%;
`;

const Adornment = styled.i`
  color: #9098a9;
`;
